export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40ca8aca327fae008a81dad6350db4a5b935fa335b&name=addToFolderEventAction!'